import React from "react";

import styles from "../JobShiftPreStart/JobShiftPreStartView.module.css";

const getRevision = (version) => {
  if (version === undefined || version === null || version === "") return "1";
  const value = `${version}`;
  return value.charAt(0).toLowerCase() === "v" ? value.slice(1) || "1" : value;
};

export default function JobShiftEmergencyPlanHeader({ plan = {}, index, sections = {}, context = {} }) {
  const projectDetails = sections.document_project_details && sections.document_project_details.data
    ? sections.document_project_details.data
    : {};
  const orgDetails = projectDetails.org_details || {};
  const orgName = orgDetails.name || "";
  const swmsVersion = projectDetails.swms_version || context.swmsVersion;
  const documentNumber = plan.document_number || "";

  return (
    <div className={styles.PreviewDocBand} style={{ borderBottom: "4px solid #e9c84a" }}>
      <div className={styles.PreviewDocBandLetter}>
        <div className={styles.PreviewDocBandMark}>{orgName ? orgName.charAt(0) : ""}</div>
        <div>
          <div className={styles.PreviewDocBandName}>{orgName}</div>
          <div className={styles.PreviewDocBandSub} style={{ color: "#f4e6a8", fontWeight: 600 }}>EMERGENCY RESCUE PLAN</div>
        </div>
      </div>
      <div className={`${styles.PreviewDocBandRight} preview-prestart-header-right`} style={{ textAlign: "right" }}>
        <div className={styles.PreviewDocBandNo}>
          <span style={{ display: "inline-block", verticalAlign: "2px", background: "#e9c84a", color: "#1f1031", fontSize: "10px", fontWeight: 800, letterSpacing: "0.8px", padding: "3px 9px", borderRadius: "999px", marginRight: "9px", lineHeight: 1 }}>ERP</span>
          {documentNumber}
        </div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Rev {getRevision(swmsVersion)} &middot; Approved</div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Controlled — Uncontrolled if Printed</div>
      </div>
    </div>
  );
}
